// src/components/RegisterForm.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { registerUser } from "../services/api";
import styles from "../css/Login.module.css"; // ✅ Apunta al CSS de Login
import { FiUserPlus, FiEye, FiEyeOff } from "react-icons/fi";

const RegisterForm = () => {
  // --- Tu lógica de estado y funciones se mantiene intacta ---
  const [form, setForm] = useState({ username: "", email: "", password: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Añadimos estado de carga

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (name === "password") evaluatePasswordStrength(value);
  };

  const evaluatePasswordStrength = (password) => {
    if (!password) return setPasswordStrength("");
    const strength = [
      password.length >= 8,
      /[A-Z]/.test(password),
      /[a-z]/.test(password),
      /[0-9]/.test(password),
      /[@$!%*?&]/.test(password),
    ].filter(Boolean).length;
    if (strength === 5) setPasswordStrength("Strong");
    else if (strength >= 3) setPasswordStrength("Moderate");
    else setPasswordStrength("Weak");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setIsLoading(true); // Inicia la carga
    try {
      const res = await registerUser(form);
      if (res.success) {
        setMessage("¡Registro exitoso! Ahora puedes iniciar sesión.");
        setForm({ username: "", email: "", password: "" }); // Limpia el form
      } else {
        setError(res.message || "El registro falló. Inténtalo de nuevo.");
      }
    } catch (err) {
      setError("Ocurrió un error inesperado.");
    } finally {
      setIsLoading(false); // Finaliza la carga
    }
  };

  return (
    // ✅ Usa la tarjeta de autenticación de Login.module.css
    <div className={styles.authCard}>
      <div className={styles.header}>
        <h2>Crea tu Cuenta</h2>
        <p>Únete a Community PRO hoy mismo.</p>
      </div>

      {/* ✅ La estructura del formulario es idéntica a LoginForm */}
      <form onSubmit={handleSubmit} className={styles.form}>
        {message && (
          <p className={`${styles.message} ${styles.success}`}>{message}</p>
        )}
        {error && (
          <p className={`${styles.message} ${styles.error}`}>{error}</p>
        )}

        <div className={styles.inputGroup}>
          <label htmlFor="username">Nombre de usuario</label>
          <input
            id="username"
            name="username"
            type="text"
            placeholder="ej: juanperez"
            onChange={handleChange}
            value={form.username}
            className={styles.input}
            required
          />
        </div>

        <div className={styles.inputGroup}>
          <label htmlFor="email">Correo Electrónico</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="tu@email.com"
            onChange={handleChange}
            value={form.email}
            className={styles.input}
            required
          />
        </div>

        <div className={styles.inputGroup}>
          <label htmlFor="password">Contraseña</label>
          <div className={styles.passwordWrapper}>
            <input
              id="password"
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="••••••••"
              onChange={handleChange}
              value={form.password}
              className={styles.input}
              required
            />
            <button
              type="button"
              className={styles.passwordToggle}
              onClick={() => setShowPassword(!showPassword)}
              aria-label="Mostrar u ocultar contraseña"
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>

        {/* ✅ Medidor de contraseña con los nuevos estilos de Login.module.css */}
        {passwordStrength && (
          <p
            className={`${styles.passwordStrength} ${
              styles[passwordStrength.toLowerCase()]
            }`}
          >
            Fortaleza: {passwordStrength}
          </p>
        )}

        <button type="submit" className={styles.button} disabled={isLoading}>
          {isLoading ? (
            <div className={styles.spinner}></div>
          ) : (
            <>
              <FiUserPlus />
              <span>Crear Cuenta</span>
            </>
          )}
        </button>
      </form>

      <div className={styles.footerText}>
        <p>
          ¿Ya tienes una cuenta?{" "}
          <Link to="/login" className={styles.link}>
            Inicia sesión
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterForm;
